module.exports = __webpack_public_path__ + "img/telegram.5676d2bf.svg";